// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__BYC8N","notes":"Notes_notes__34WFT","note":"Notes_note__4SjUd","markdown":"Notes_markdown__3DpVT"};